import React from 'react';
import {
  Text,
  Button,
  makeStyles,
  tokens,
} from '@fluentui/react-components';
import { PersonAdd24Regular } from '@fluentui/react-icons';

const useStyles = makeStyles({
  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    height: '100vh',
    gap: tokens.spacingVerticalL,
    padding: tokens.spacingHorizontalXXXL,
    textAlign: 'center',
    background: tokens.colorNeutralBackground2,
  },
  icon: { color: tokens.colorBrandForeground1 },
  card: {
    background: tokens.colorNeutralBackground1,
    borderRadius: tokens.borderRadiusLarge,
    border: `1px solid ${tokens.colorNeutralStroke2}`,
    padding: tokens.spacingVerticalXL,
    maxWidth: '400px',
    display: 'flex',
    flexDirection: 'column',
    gap: tokens.spacingVerticalM,
    alignItems: 'center',
  },
});

interface Props {
  user: { displayName: string; microsoftUpn: string };
}

export default function NotMapped({ user }: Props) {
  const styles = useStyles();
  return (
    <div className={styles.container}>
      <div className={styles.card}>
        <PersonAdd24Regular className={styles.icon} style={{ fontSize: 48 }} />
        <Text size={500} weight="semibold">Compte non lié</Text>
        <Text size={300} style={{ color: tokens.colorNeutralForeground2 }}>
          Bonjour <strong>{user.displayName}</strong>, votre compte Microsoft ({user.microsoftUpn}) n'est pas encore associé à un utilisateur BoondManager.
        </Text>
        <Text size={300} style={{ color: tokens.colorNeutralForeground3 }}>
          Veuillez contacter votre administrateur Gridwise pour configurer la correspondance entre votre compte Teams et Boond.
        </Text>
        <Button
          appearance="primary"
          onClick={() => window.location.reload()}
        >
          Réessayer
        </Button>
      </div>
    </div>
  );
}
